import React from 'react';
import bowser from 'yola-bowser';
import IconButton from '../../../icon-button';
const isMobile = bowser.mobile;

const TreeViewItemActions = ({ actions, disabled = false }) => (
  <div className="ws-ui-tree-view-item-actions">
    {actions.map(({ onClick, label, glyph }) => {
      const handleClick = (event) => {
        event.stopPropagation();

        onClick();
      };

      return (
        <div className="ws-ui-tree-view-item-actions__action" key={label}>
          <IconButton
            appearance="accent"
            size={isMobile ? 'medium' : 'small'}
            disabled={disabled}
            transparent
            label={label}
            glyph={glyph}
            onClick={handleClick}
          />
        </div>
      );
    })}
  </div>
);

export default TreeViewItemActions;
